import { render, staticRenderFns } from "./AddMealThanks.vue?vue&type=template&id=1f741e4c&scoped=true&"
import script from "./AddMealThanks.vue?vue&type=script&lang=js&"
export * from "./AddMealThanks.vue?vue&type=script&lang=js&"
import style0 from "./AddMealThanks.vue?vue&type=style&index=0&id=1f741e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f741e4c",
  null
  
)

export default component.exports